<template>
  <div class="container">
    
    <Modal v-model="importResultModal" title="导入结果">
      <div class="import-result-modal">
        <h3>111</h3>
        <!-- <h3>
          成功导入{{
            importResultData ? importResultData.successImportCount : ""
          }}个，错误信息{{
            importResultData ? importResultData.errorData.length : ""
          }}个
        </h3>
        <div v-for="item in importResultList">{{ item }}</div> -->
      </div>
    </Modal>
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        >
        </Input>
        <Select
          placeholder="筛选人员"
          v-model="selectUser"
          label-in-value
          multiple
          filterable
          @on-change="choseUser"
          style="width: 220px; margin-right: 30px"
        >
          <Option
            v-for="item in simpleUserList"
            :value="item._id"
            :key="item._id"
          >{{ item.name }}</Option>
        </Select>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalCounts }}条</span>
          <Page
            :total="totalCounts"
            :page-size="20"
            @on-change="loadCustomerQZTable"
            show-total
            simple
            style="margin-right: 24px"
          />
        </div>
        <Button
          type="error" ghost
          style="margin-right: 20px"
          @click="removeBannedUserQZBtnClick"
  
          >清除离职可见人</Button
        >
        <!-- <Button
          style="margin-right: 20px"
          @click="$refs.ImportQZTableModal.openModal()"
          >导入权责表</Button
        > -->
        <Button
          style="margin-right: 20px"
          @click="exportQZTable()"
          :loading="exportQZTableLoading"
          >导出权责表</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :data="customerQZList"
        :height="tableHeight"
        :loading="tableLoading"
        border
      ></Table>
    </div>
    <ImportQZTableModal
      ref="ImportQZTableModal"
      @importResult="openImportResultModal"
    />
    <CustomerQZUpdateFormDrawer ref="CustomerQZUpdateFormDrawer" />

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import ImportQZTableModal from "./ImportQZTableModal.vue";
import CustomerQZUpdateFormDrawer from "./CustomerQZUpdateFormDrawer.vue";
import axios from "@/utils/axios";
import dayjs from "dayjs";
import _ from "lodash";

export default {
  name: "ImportCustomerQZTable",
  components: {
    ImportQZTableModal,
    CustomerQZUpdateFormDrawer,
  },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      selectUser: null,
      tableLoading: false,
      importResultModal: false,
      exportQZTableLoading: false,
      limit: 20,
      page: 0,
      filterQuery: {},
      columns: [
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          minWidth: 140,
          maxWidth: 280,
          render: (h, params) => {
            return h("span", {
              style: {
                cursor: "pointer",
                color: "#42b983",
              },
              on: {
                click: () => {
                  this.$refs.CustomerQZUpdateFormDrawer.openDrawer(params)
                },
              },
            }, params.row.abbr || params.row.name);
          },
        },
        {
          title: "开发",
          key: "devSales",
          minWidth: 140,
          maxWidth: 200,
          render: (h, params) => {
            return h("span", params.row.comissionDivDev?.map((x) => {
              let ratioText = '-';
              if (x.ratio) ratioText = `${(x.ratio*100).toFixed(0)}%`;
              return x.user.name + ' ' + ratioText;
            }).join("、"));
          },
        },
        {
          title: "维护",
          key: "maintainSales",
          minWidth: 140,
          maxWidth: 200,
          render: (h, params) => {
            return h("span", params.row.comissionDivMaintain?.map((x) => {
              let ratioText = '-';
              if (x.ratio) ratioText = `${(x.ratio*100).toFixed(0)}%`;
              return x.user.name + ' ' + ratioText;
            }).join("、"));
          },
        },
        {
          title: "回款",
          key: "paymentSales",
          minWidth: 140,
          maxWidth: 200,
          render: (h, params) => {
            return h("span", params.row.comissionDivPayment?.map((x) => {
              let ratioText = '-';
              if (x.ratio) ratioText = `${(x.ratio*100).toFixed(0)}%`;
              return x.user.name + ' ' + ratioText;
            }).join("、"));
          },
        },
        {
          title: "区域经理",
          key: "regionalCharger",
          width: 100,
          render: (h, params) => h("span", params.row.regionalCharger?.name),
        },
        {
          title: "销售可见人",
          key: "salesVisibleMember",
          width: 140,
          render: (h, params) => h("span", params.row.salesVisibleMember?.map(v => v.name).join('、')),
        },
        {
          title: "技术可以见人",
          key: "techVisibleMember",
          minWidth: 140,
          render: (h, params) => h("span", params.row.techVisibleMember?.map(v => v.name).join('、')),
        },

        // {
        //   title: "比例分配",
        //   key: "comissionDiv",
        //   fixed: "left",
        //   minWidth: 140,
        //   render: (h, params) => {
        //     return h(
        //       "span",
        //       params.row.comissionDiv
        //         ? params.row.comissionDiv
        //             .map((x) => x.user.name + x.ratio * 100 + "%")
        //             .join("、")
        //         : ""
        //     );
        //   },
        // },
      ],
    };
  },
  computed: mapState({
    currentUser: (state) => state.auth.currentUser,
    user: (state) => state.auth.currentUser,
    customerQZList: (state) => state.customer.customerQZList,
    totalCounts: (state) => state.customer.totalCounts,
    simpleUserList: (state) => state.user.simpleUserList,
  }),
  methods: {
    ...mapActions({
      getCustomerQZList: "customer/getCustomerQZListAction",
      removeBannedUserQZ: "customerQZUpdateForm/removeBannedUserQZAction",
      getSimpleUserList: "user/getSimpleUserListAction",
    }),
    async loadCustomerQZTable(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        await this.getCustomerQZList(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadCustomerQZTable();
    }, 1000),
    async choseUser(e) {
      if (e.length > 0) {
        const selectUser = e.map(x => x.value).join(",");
        this.filterQuery.searchUser = selectUser
      } else {
        delete this.filterQuery.searchUser
      }
      this.loadCustomerQZTable();
    },
    openImportResultModal(e) {
      this.importResultModal = true;
      this.importResultData = e;
      this.importResultList = e.errorData;
    },
    async exportQZTable () {
      this.exportQZTableLoading = true
      try {
        const res = await axios.get(`/export_qz_list_table`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `权责表${dayjs().format("MM-DD-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        this.$Message.success("导出成功!");
      } catch (error) {
        this.$Message.error({
          content: `导出失败!${error}`,
          closable: true,
          duration: 0,
        });
      }
      this.exportQZTableLoading = false
    },
    async removeBannedUserQZBtnClick() {
      try {
        await this.removeBannedUserQZ()
        this.$Message.success('成功清除')
      } catch (error) {
        this.$Message.error(error)
      }
    },
  },
  created() {
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    this.loadCustomerQZTable();
    this.getSimpleUserList({ showAll: true, limit: 999 })
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)

.page-wrap
  display flex
</style>